export default __webpack_public_path__ + "static/media/general_si_purchasing_conditions_Fincantieri_SI_ENG.140f9c05.pdf";